import { PartitionNumberRangePattern } from "./PartitionNumberRangePattern.mjs";
function FormatNumericRange(numberFormat, x, y, _a) {
  var getInternalSlots = _a.getInternalSlots;
  var parts = PartitionNumberRangePattern(numberFormat, x, y, {
    getInternalSlots
  });
  return parts.map(function(part) {
    return part.value;
  }).join("");
}
export {
  FormatNumericRange
};
